export const envs = {
  api: {
    configApi: process.env.REACT_APP_CONFIG_API_EXCHANGE,
    apiProduction: process.env.REACT_APP_BASE_API_PRODUCTION,
    apiDeveloper: process.env.REACT_APP_BASE_API_DEVELOPER,
  },

  names: {
    nameApp: process.env.REACT_APP_NAME_APP,
    nameScore: process.env.REACT_APP_NAME_SCORE,
    nameStore: process.env.REACT_APP_NAME_STORE,
    nameAcademy: process.env.REACT_APP_NAME_ACADEMY,
  },

  colors: {
    primaryColor: process.env.REACT_APP_PRIMARY_COLOR,
    primaryColorLight: process.env.REACT_APP_PRIMARY_COLOR_LIGTH,
    secondaryColor: process.env.REACT_APP_SECONDARY_COLOR,
    labelColor: process.env.REACT_APP_LABEL_COLOR,
    textInput: process.env.REACT_APP_TEXT_COLOR_INPUTS,
  },

  menu: {
    menuMural: process.env.REACT_APP_MENU_MURAL,
    menuGroupPardini: process.env.REACT_APP_MENU_GROUP_PARDINI,
    menuAboutUs: process.env.REACT_APP_MENU_ABOUT_US,
    menuFavorite: process.env.REACT_APP_MENU_FAVORITE,
    menuCalendar: process.env.REACT_APP_MENU_CALENDAR,
    menuScoreHistory: process.env.REACT_APP_MENU_SCORE_HISTORY,
    menuBirthdays: process.env.REACT_APP_MENU_BIRTHDAYS,
    menuAcademy: process.env.REACT_APP_MENU_ACADEMY,
    menuStore: process.env.REACT_APP_MENU_STORE,
    menuTeams: process.env.REACT_APP_MENU_TEAMS,
    menuFiles: process.env.REACT_APP_MENU_FILES,
    menuApps: process.env.REACT_APP_MENU_APPS,
    menuConfigurations: process.env.REACT_APP_MENU_CONFIGURATIONS,
  },
};
